<script setup>
import { computed, ref, watch } from 'vue';
import { useKaleadicalStore } from '@/stores/kaleadical';
import PreviewShapeComponent from '@/components/PreviewShapeComponent.vue';
import { router } from '@inertiajs/vue3';
import { storeToRefs } from 'pinia';

const { incrementItem } = useKaleadicalStore();
const { kaleadical } = storeToRefs(useKaleadicalStore());

const incrementedItems = ref([]);
const imageExists = ref(true);

const increment = (item) => {
    incrementedItems.value.push(item.id);
    incrementItem({
        hash: kaleadical.value.hash,
        itemHash: item.hash
    }).then(() => {
        setTimeout(() => {
            incrementedItems.value = incrementedItems.value.filter((id) => id !== item.id);
        }, 300);
    });
};

const imageUrl = computed(() => {
    return `/api/v1/kaleadicals/${kaleadical.value.hash}/image?${Date.now()}`;
});

watch(() => kaleadical, () => {
    console.warn('kaleadical', kaleadical);
});

const viewKaleadical = () => {
    router.visit('/kaleadicals/view/' + kaleadical.value.hash);
};

const editKaleadical = () => {
    router.visit('/kaleadicals/create/' + kaleadical.value.hash);
};

const handleImageError = () => {
    imageExists.value = false;
};

</script>

<template>
<MainContentLayout>
    <div class="w-full flex justify-between items-center">
        <div class="font-bold text-2xl">Kaleadical {{ kaleadical.name }}</div>
        <div class="text-blue-500 cursor-pointer text-lg hover:text-blue-700 underline" @click="editKaleadical">Edit</div>
    </div>
    <div class="space-y-5">
        <StyledButton
            class="w-full"
            color="secondary"
            full
            size="x-large"
            @click="viewKaleadical()">
            <v-icon icon="mdi-shape" class="mr-2" /> View Kaleadical
        </StyledButton>

        <div class="flex justify-center">
            <img
                v-if="imageExists"
                :src="imageUrl"
                class="w-32 h-32 object-cover"
                @error="handleImageError">
        </div>

        <v-card
            v-for="item in kaleadical.items"
            :key="item.id"
            :title="item.name"
            class="border">
            <v-card-text>
                <div class="mb-4">
                    <PreviewShapeComponent :preview-code="item.shape.definition" :scale="item.shape.scale" />
                    Count {{ item.shapes_count }}
                </div>
                <StyledButton
                    :disabled="incrementedItems.includes(item.id)"
                    color="primary"
                    @click="increment(item)">
                    <template v-if="incrementedItems.includes(item.id)">
                        <FontAwesomeIcon class="mr-2" icon="check" /> Incremented
                    </template>
                    <template v-else>
                        <FontAwesomeIcon class="mr-2" icon="plus" /> Increment
                    </template>
                </StyledButton>
            </v-card-text>
        </v-card>
    </div>
</MainContentLayout>
</template>
